'use strict';
import angular from 'angular';
import moment from 'moment';
import _ from 'lodash';
import creativePreviewHtml from '../views/directive_creativePreview.html';

angular.module('creatives.ctrls', [])
    .controller('CreativeLibraryController', CreativeLibraryController)
    .controller('CreativeViewController', CreativeViewController);

CreativeLibraryController.$inject = ['$rootScope', '$scope', '$timeout', 'UserService', 'ClusterService', '$state', '$ioAlert', '$stateParams', '$modal', 'ModalService', 'creativesService'];

function CreativeLibraryController($rs, $scope, $timeout, UserService, ClusterService, $state, $ioAlert, $stateParams, $modal, ModalService, creativesService) {
    $scope.creatives = [];
    $scope.creative = null;

    $scope.pageObj = {
        perPageOptions: [1, 2, 50, 100],
        perPage: 50,
        search: '',
        currentPage: 1,
        totalCount: 0,
        startIndex: 1,
        endIndex: 1,
        maxSize: 5,
        calculate: function() {
            $scope.pageObj.startIndex = Math.ceil((($scope.pageObj.currentPage - 1) * $scope.pageObj.perPage) + 1);
            $scope.pageObj.endIndex = Math.min(($scope.pageObj.currentPage) * $scope.pageObj.perPage);
            if ($scope.pageObj.endIndex > $scope.pageObj.totalCount) {
                $scope.pageObj.endIndex = $scope.pageObj.totalCount;
            }
        }
    };
    $scope.$watch('pageObj.currentPage', function() {
        $scope.pageObj.calculate();
    });
    $scope.$watch('pageObj.perPage', function() {
        $scope.pageObj.calculate();
    });




    $scope.getCreatives = function(orderBy) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Creatives";

        var params = {
            "clusterIds": ClusterService.clusterIds,
            "thumbWidth": 100
        };
        params.page = $scope.pageObj.currentPage;
        params.perPage = $scope.pageObj.perPage;
        params.search = $scope.pageObj.search;
        if (orderBy) {
            params.orderBy = orderBy;
            
        switch(params.orderBy){
            case 'cluster_name':  params.orderBy = "clusters.name"; break;
            case 'format':  params.orderBy = "creative.format"; break;
            case 'client_id':  params.orderBy = "creative.client_id"; break;
            case 'name':  params.orderBy = "creative.file_name"; break;
            case 'created_at':  params.orderBy = "creative.created_at"; break;
            case 'updated_at':  params.orderBy = "creative.updated_at"; break;
        }
            if ($scope.sortReverse == true){
                params.orderType = 'ASC';
            }else{
                params.orderType = 'DESC';
            }
        }

        creativesService.getCreatives(params).then(function(success) {
            $scope.creatives = _.map(success.creatives, function(creative) {
                creative.created_at = moment(creative.created_at).local().format('YYYY-MM-DD HH:mm');
                creative.updated_at = moment(creative.updated_at).local().format('YYYY-MM-DD HH:mm');

                return creative;
            });
            $rs.loadingInProgress = false;
            $scope.pageObj.totalCount = success.total_count;
            $scope.pageObj.currentPage = success.page;
            $scope.pageObj.calculate();
        }, function(error) {
            $ioAlert.show('Error!', 'Could not get Creatives.', 'error');
            $rs.loadingInProgress = false;
        });
    };

    $scope.showPreview = function(creative) {
        var data = {};
        $modal.open({
            animation: true,
            controller: function($scope, creative) {
                $scope.creativeObj = creative;
            },
            templateUrl: creativePreviewHtml,
            resolve: {
                creative: function() {
                    return creative;
                }
            }
        });
    };

    function deleteCreativeModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    $scope.delete = function(creative) {
        deleteCreativeModal('deleteCreative', { filename: creative.file_name }).result.then(function(selectedItem) {
            if (selectedItem == 'ok') {
                var params = {
                    "id": creative.id
                };
                creativesService.deleteCreativeLibrary(params).then(function(success) {
                    $ioAlert.show("Success!", "Creative Deleted Successfully", 'success');
                    $scope.getCreatives();
                }, function(error) {
                    $ioAlert.show('Error!', 'Could not get Delete creative.', 'error');
                });
            }
        }, function() {
            // dismiss modal
        });
    };

    $scope.viewCreative = function(creative) {
        $state.go('viewCreative', {
            creativeId: creative.id
        });
    };

    $scope.showOrders = function(creative) {
        var data = {};
        data.creative = creative;
        ModalService.returnModalType('creativeToLineItem', data).result.then(function() {}, function(cancel) {
            console.log("cancel");
        })
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        $scope.isAdmin = ($rs.userRole.permissions == 'superadmin' || $rs.userRole.permissions == 'adops,admin');
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.getCreatives();
        $timeout(function() {
            $scope.customersActive = false;
            $scope.$apply();
        });
    });
}

CreativeViewController.$inject = ['$rootScope', '$timeout', '$scope', 'UserService', 'ClusterService', '$state', '$ioAlert', '$stateParams', 'ModalService', 'creativesService'];

function CreativeViewController($rs, $timeout, $scope, UserService, ClusterService, $state, $ioAlert, $stateParams, ModalService, creativesService) {
    $scope.creative = null;

    $scope.getCreative = function() {
        var params = {
            'id': $stateParams.creativeId,
            'thumbWidth': 300
        };

        creativesService.getCreative(params).then(function(success) {
            $scope.creative = success.creative;
            $scope.secure_url = $scope.creative.secure_url;
        }, function(error) {
            $ioAlert.show('Error!', 'Could not get Available Users.', 'error');
        });
    };

    $scope.backtoCreativeLibrary = function() {
        $state.go('creativeLibrary');
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'hidden');
        $scope.getCreative();
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        $scope.getCreative();
        $timeout(function() {
            $scope.customersActive = false;
            $scope.$apply();
        });
    })
}